import React from 'react';
import Image from '../PageElements/Image/Image';
import TextWithReferences from '../PageElements/TextWithReferences/TextWithReferences';

type Properties = {
    term: string;
    desc: string;
    imageId?: string;
};

const ApproachAvoidCard = (props: Properties) => {
    const { term, desc, imageId } = props;

    const [turned, setTurned] = React.useState<boolean>(false);

    let image = <></>;
    if (imageId) {
        image =
            <Image
                data={{
                    type: 'image',
                    id: imageId
                }}
            />;
    }

    const toggleTurned = () => {
        setTurned(!turned);
    };

    let className = 'explanation-card card-';
    if (turned) {
        className += 'turned';
    } else {
        className += 'unturned';
    }

    return (
        <div onClick={toggleTurned}>
            <div className={className}>
                <div className="term">
                    {image}
                    <TextWithReferences text={term} />
                </div>
                <div className="desc">
                    <TextWithReferences text={desc} />
                </div>
            </div>
        </div>
    );
};

export default ApproachAvoidCard;
